<script setup lang="ts">
const { LocalConfigurationStore } = stores()
</script>

<template>
  <div class="bg-primary flex flex-col items-center justify-center py-4">
    <LayoutContainer id="header-container ">
      <div class="flex items-center justify-between h-full">
        <a href="/">
          <ImageComponent
            :src="LocalConfigurationStore?.siteInfo?.logoUrl"
            :alt="LocalConfigurationStore?.siteInfo?.brokerName"
            class="h-8 lg:h-10 cursor-pointer"
          />
        </a>
        <img
          src="/img/powered-by-contigo.png"
          alt="Contigo"
          class="h-8 lg:h-10"
        />
      </div>
    </LayoutContainer>
  </div>
</template>
